const getCountriesCount = (state) => {
  return state.main.countriesState.countriesCount
}
const getFetchCountriesListCountRequestState = (state) => {
  return state.main.countriesState.fetchCountriesListCountRequestState
}
const getFetchCountriesListRequestState = (state) => {
  return state.main.countriesState.fetchCountriesRequestState
}
const getCountriesFilters = (state) => {
  return state.main.countriesState.countriesFilters
}
const getCountriesList = (state) => {
  return state.main.countriesState.countries
}
const getCountriesListOffset = (state) => {
  return state.main.countriesState.countriesPaginationOffset
}
const getAddCountryRequestState = (state) => {
  return state.main.countriesState.addCountryRequestState
}

const CountriesSelectors = {
  getCountriesCount,
  getFetchCountriesListCountRequestState,
  getCountriesFilters,
  getCountriesList,
  getCountriesListOffset,
  getFetchCountriesListRequestState,
  getAddCountryRequestState,
}

export default CountriesSelectors
